import React from 'react'
import { Link } from "react-router-dom"

const Menu = ({rule,index}) => {
    const menu =  rule.ContentRuleZone?.[0];
    return ( <> {menu?.attributes?.link?.startsWith('http') ?
                        <li key={index}>
                            <a className="dropdown-item" href={menu?.attributes?.link ? menu.attributes.link : '#'} target="_blank">
                                {menu?.attributes?.displayName ?? ""}
                            </a>
                        </li> :

                        <li key={index} >
                            <Link className="dropdown-item" to={menu?.attributes?.link ? menu.attributes.link : '#'}>
                                {menu?.attributes?.displayName ?? ""}
                            </Link>
             </li>  }
    </>)
}

export default Menu